'use client';

import { HomeLayout } from '@/screens/home/layout';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const items = [
  {
    header: 'What courses does Debug Media offer?',
    content:
      'Debug Media offers a wide range of coding and interview/job related courses tailored for beginners and experienced professionals. From web development (HTML, CSS, JavaScript) to advanced topics like React, Node.js, Python, Git, Preparing for Interview, and more, we cover everything you need to kickstart or advance in your career. All courses are delivered in Malayalam to ensure ease of learning for the Kerala community.',
  },
  {
    header: 'How can I access Debug Media courses?',
    content:
      'You can access all our online courses through our website. Simply sign up, browse the course catalog, and start learning immediately. Our courses are designed to be self-paced, allowing you to learn at your convenience.',
  },
  {
    header: 'Do I need prior coding experience to start learning?',
    content:
      'No, you don"t need any prior coding experience! Debug Media offers beginner-friendly courses designed to teach you programming from scratch. Our step-by-step tutorials will help you build a solid foundation before advancing to more complex topics. \n\nBut we do offer Advance courses which is not beginner friendly and requires prior coding experience. This is mentioned in the course description.',
  },
  {
    header: 'Is there any 24/7 support available for students?',
    content:
      'Yes, Debug Media offers 24/7 support to assist you with any issues you encounter while learning. Whether it"s a technical problem, a question about a course topic, or personalized guidance, our team is always ready to help.',
  },
  {
    header: 'How long is the support available?',
    content:
      'Support is available for the entire duration of the course you enroll in. \n\nFor example, if the course lasts 3 months, personal support will be provided throughout that period. Similarly, if the course duration is 6 months, support will be available for the full 6 months.',
  },
  {
    header: 'What is Book 1:1?',
    content:
      'This is for people who would want to have a 1:1 session with a Debug Media. \n\nIn this future we will offer online sessions with experienced professionals who can help you in your learning journey.',
  },
];

type subTitleClassProps = {
  subTitleClassName: string;
};

export const Faq = ({ subTitleClassName }: subTitleClassProps) => {
  return (
    <HomeLayout className='mt-[60px]'>
      <h3 className={subTitleClassName}>Frequently Asked Questions </h3>
      <Accordion type='single' collapsible className='w-full mt-8 md:mt-16'>
        {items.map(({ header, content }, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger className='bg-brand-secondary rounded-lg p-6 mb-0  text-sm md:text-lg text-left'>
              {header}
            </AccordionTrigger>
            <AccordionContent className='bg-brand-secondary p-6 text-sm md:text-md leading-6 font-light mb-2 whitespace-break-spaces rounded-b-lg'>
              {content}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </HomeLayout>
  );
};
